<template>
    <el-switch
        class="base-switch"
        data-testid="input-switch"
        v-bind="$attrs"
        v-on="listeners"
    />
</template>

<script setup lang="ts">
import { useListeners } from 'vue'

const listeners = useListeners()
</script>

<style lang="scss">
    .base-switch, .el-switch.base-switch {
        .el-switch__label {
            color: var(--mainTextColor-color);
        }
        &.is-checked .el-switch__core {
            @apply bg-active-elements border-active-elements;
        }
        .el-switch__label.is-active {
            @apply text-active-elements;
        }
    }
    [dir='rtl'], .rtl {
        .base-switch, .el-switch.base-switch {
            .el-switch__label--right {
                margin-left: 0;
                margin-right: 12px;
            }
            .el-switch__label--left {
                margin-left: 12px;
                margin-right: 0;
            }
        }
    }
</style>
